// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Senegal */
const SN = /^(?:7(?:[015-8]\d|21|90)\d{6})$/;

export default SN;
